import React from 'react'
import { RealEstateDataPageComponentData } from 'types'

const SummaryNovelties_5 = (props: RealEstateDataPageComponentData) => {
  const SummaryNovelties = require(`../1`)?.default
  return (
    <SummaryNovelties
      {...props}
      darkMode={true}
    />
  )
}

export default SummaryNovelties_5
